<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-xl-8 col-lg-9 col-md-10">
      <form [formGroup]="notificationForm" (ngSubmit)="submit()">
        <div class="card shadow-sm">
          <div
            class="card-header d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">Send Promotional Notification</h5>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="goToNotificationHistory()"
            >
              <i class="fa fa-history me-2"></i>

              View Notification History
            </button>
          </div>

          <div class="card-body">
            <!-- Audience + Title -->
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label fw-bold"> Audience </label>

                <select class="form-select" formControlName="audience">
                  <option value="">Select Audience</option>
                  <option value="DRIVER">Drivers</option>
                  <option value="USER">Users</option>
                </select>

                <small
                  class="text-danger"
                  *ngIf="
                    notificationForm.get('audience')?.touched &&
                    notificationForm.get('audience')?.invalid
                  "
                >
                  Audience is required.
                </small>
              </div>

              <div class="col-md-8 mb-3">
                <label class="form-label fw-bold"> Notification Title </label>

                <input
                  type="text"
                  maxlength="100"
                  class="form-control"
                  placeholder="Enter notification title"
                  formControlName="title"
                />

                <div class="d-flex justify-content-between mt-1">
                  <small
                    class="text-danger"
                    *ngIf="
                      notificationForm.get('title')?.touched &&
                      notificationForm.get('title')?.invalid
                    "
                  >
                    Title is required.
                  </small>

                  <small class="text-muted ms-auto">
                    {{ notificationForm.get("title")?.value?.length || 0 }}/100
                  </small>
                </div>
              </div>
            </div>

            <!-- Message -->

            <div class="mb-3">
              <label class="form-label fw-bold"> Message </label>

              <textarea
                rows="5"
                maxlength="500"
                class="form-control"
                placeholder="Write your promotional notification..."
                formControlName="message"
              >
              </textarea>

              <div class="d-flex justify-content-between mt-1">
                <small
                  class="text-danger"
                  *ngIf="
                    notificationForm.get('message')?.touched &&
                    notificationForm.get('message')?.invalid
                  "
                >
                  Message is required.
                </small>

                <small class="text-muted ms-auto">
                  {{ notificationForm.get("message")?.value?.length || 0 }}/500
                </small>
              </div>
            </div>

            <!-- Image URL -->

            <div class="mb-4">
              <label class="form-label fw-bold">
                Notification Banner (Optional)
              </label>

              <input
                #fileInput
                type="file"
                class="form-control"
                accept="image/*"
                (change)="onImageSelected($event)"
              />

              <small class="text-muted">
                Supported: JPG, PNG, WEBP (Max 2 MB)
              </small>
            </div>

            <div class="text-center mb-4" *ngIf="imagePreview">
              <img
                [src]="imagePreview"
                class="img-thumbnail shadow-sm"
                style="max-height: 220px"
              />
            </div>

            <!-- Buttons -->

            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="notificationForm.invalid || uploadingImage"
            >
              <span *ngIf="uploadingImage">
                <i class="fa fa-spinner fa-spin"></i>

                Uploading...
              </span>

              <span *ngIf="!uploadingImage">
                <i class="fa fa-paper-plane"></i>

                Send Notification
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
